export enum QuickFiltersVariant {
  Default = 'default',
  Blue = 'blue',
}
